// extracted by mini-css-extract-plugin
export default {"button":"navigationButton_button__FUyb9"};